import { useStore } from '@stores';
import { useTenantVat } from '@hooks';
import { useEffect } from 'react';

export const useOrder = (id: string | undefined) => {
  const { orderStore, serviceStore, vehicleStore } = useStore();
  const { order, loading } = orderStore;
  const vat = useTenantVat();

  useEffect(() => {
    id && orderStore.get({ id });

    return () => {
      orderStore.resetOrder();
      serviceStore.clearOrderServices();
      vehicleStore.clearVehicle();
    };
  }, [orderStore, serviceStore, vehicleStore, id]);

  // Init services from order once loaded
  useEffect(() => {
    if (order) {
      serviceStore.initFromOrder(order, vat);
    }
  }, [order, vat, serviceStore]);

  return { order, loading };
};
